import React from 'react';
import ReactDOM from 'react-dom';
import Calculator from './App';

ReactDOM.render(
  <Calculator/>,
  document.getElementById('root')
);
